import type {
  TPlatformNavigator,
  TPwaPlatform,
} from './usePwaInstall.types.ts';

const iosUserAgentPattern = /iphone|ipad|ipod/i;
const macUserAgentPattern = /macintosh/i;

export const getPlatform = (
  hasInstallPrompt: boolean,
  { userAgent, maxTouchPoints }: TPlatformNavigator,
): TPwaPlatform => {
  if (hasInstallPrompt) {
    return 'installable';
  }

  const isIpadAsMac = macUserAgentPattern.test(userAgent) && maxTouchPoints > 1;

  if (iosUserAgentPattern.test(userAgent) || isIpadAsMac) {
    return 'ios';
  }

  return 'unsupported';
};
